import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutComponent } from '../layout/layout.component';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { RootState } from '../../core/stores/store';
import { UserActions } from '../../core/stores/user/user.actions';
import { User } from '../../shared/interfaces/user.interfaces';
import { selectCurrentUser } from '../../core/stores/user/user.selectors';
import { selectLoggedIn } from '../../core/stores/app/app.selectors';
import { firstValueFrom, Observable, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { PermissionService } from '../../core/local-services/permission.service';
import { AppActions } from '../../core/stores/app/app.actions';

@Component({
  selector: 'app-main',
  imports: [
    CommonModule,
    LayoutComponent,
    RouterModule
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})

export class MainComponent implements OnInit, OnDestroy {

  currentUser$: Observable<User | undefined>;
  loggedIn$: Observable<boolean | undefined>;

  constructor(
    private store: Store<RootState>,
    private router: Router,
    private permissionService: PermissionService
  ) {
    this.currentUser$ = this.store.select(selectCurrentUser);
    this.loggedIn$ = this.store.select(selectLoggedIn);
  }

  ngOnInit(): void {

    (async () => {
      this.currentUser$.pipe(take(1)).subscribe(user => {
        if (!user) {
          this.router.navigate(['/login']);
        }
      });

      const navEntries = performance.getEntriesByType('navigation');
      let isReload = navEntries.length && (navEntries[0] as PerformanceNavigationTiming).type === 'reload';
      let loggedIn = await firstValueFrom(this.loggedIn$);
      if (isReload && loggedIn) {
        return;
      } else {
        this.store.dispatch(AppActions.setLoggedStatus({ loggedIn: true }));
        const canViewDashboard = await firstValueFrom(this.permissionService.isAllowed('viewDashboard'));
        if (canViewDashboard) {
          this.router.navigate(['/main/dashboard']);
          return;
        }
        const canListEquipments = await firstValueFrom(this.permissionService.isAllowed('listEquipments'));
        if (canListEquipments) {
          this.router.navigate(['/main/equipments']);
          return;
        }
        const canGetAccounts = await firstValueFrom(this.permissionService.isAllowed('getAccounts'));
        if (canGetAccounts) {
          this.router.navigate(['/main/accounts']);
          return;
        }
        const canListUsers = await firstValueFrom(this.permissionService.isAllowed('listUsers'));
        if (canListUsers) {
          this.router.navigate(['/main/members']);
          return;
        }
        const canListSubDealers = await firstValueFrom(this.permissionService.isAllowed('listSubDealers'));
        if (canListSubDealers) {
          this.router.navigate(['/main/dealers']);
          return;
        }
        this.store.dispatch(UserActions.unsetUser());
        this.router.navigate(['/login']);
      }
    })();

    this.store.dispatch(AppActions.unsetError());
  }

  ngOnDestroy(): void {
    this.store.dispatch(UserActions.unsetUser());
  }

}
